import React from 'react';
import PropTypes from 'prop-types';
import FormattedDate from './FormattedDate';
import { parseISOLocal } from '../../utils/date';

const DateTime = ({ date }) => {
  var dateObj = parseISOLocal(date);

  return (
    <span className="DateTime">
      <FormattedDate date={dateObj} />
    </span>
  );
};

DateTime.propTypes = {
  date: PropTypes.string
};

export default DateTime;
